import React, { Fragment, useCallback, useState } from "react";
import styled from "styled-components";
import { Badge, Dropdown, Modal } from "react-bootstrap";
import { logoutAction } from "./Auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import TopMenu from "./Dashboard/TopMenu";
import { menuDashboard } from "./Dashboard/menuConstants";
import { BinIcon } from "../components/Icon/Icon";
import Profile from "./Profile/Profile";
import { getAppUser, getUserIsClient, getUserIsVerified } from "../app/appSelectors";
import { getLoggedIn } from "./Auth/authSelectors";
import { Link } from "react-router-dom";
import { useAccessContext } from "./AccessLevels/AccessContext";
import amountFormat from "../utils/amountFormat";
import RoutePaths from "../app/routePaths";

const HeaderStyled = styled.div`
    background: var(--color-bg-header);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
const HeaderLogoStyled = styled.a`
    display: block;
    cursor: pointer;
    padding: 16px;
    position: relative;
`;
const HeaderActionsStyled = styled.div`
    padding: 0 10px;

    svg {
        fill: white;
    }
`;

const DropdownToggle = styled(Dropdown.Toggle)`
    color: #FFF !important;
    background: transparent !important;
    border: 0 !important;
    padding: 12px !important;

    &:after {
        display: none !important;
    }

    &.btn {
        border-radius: 0 !important;
        //box-shadow: none !important;
    }
`;

const Header = () => {
    const dispatch = useDispatch();
    const [showProfile, setShowProfile] = useState(false);
    const loggedIn = useSelector(getLoggedIn);
    const user = useSelector(getAppUser);
    const userIsVerified = useSelector(getUserIsVerified);
    const userIsClient = useSelector(getUserIsClient);
    const logout = useCallback(() => dispatch(logoutAction()), [dispatch]);
    const openProfile = useCallback(() => setShowProfile(true), []);
    const closeProfile = useCallback(() => setShowProfile(false), []);
    const logoutHandler = useCallback(() => {
        logout();
    }, [logout]);
    // @ts-ignore
    const { checkAccess } = useAccessContext();

    return <HeaderStyled>
        <HeaderLogoStyled href={RoutePaths.main}>
            <img src="/assets/logo_text.png" alt="" height={'24px'}/>
        </HeaderLogoStyled>

        {
            !!loggedIn && !!userIsVerified && <>
                <TopMenu items={menuDashboard} className={'d-none d-lg-flex'}/>
                {
                    !!userIsClient && <>
                        <div className={'d-none d-sm-inline-block'}><Badge bg={'info'}>Full Name</Badge> {user.username}</div>
                        <div className={'d-none d-sm-inline-block'}><Badge bg={'info'}>Current
                            Balance</Badge> ${amountFormat(user.balance)}</div>
                    </>
                }
            </>
        }

        <HeaderActionsStyled>
            {
                !!loggedIn &&
                <Dropdown>
                    <DropdownToggle>
                        <BinIcon name="IcMenuBurger" stroke="#FFF"/>
                    </DropdownToggle>
                    <Dropdown.Menu style={{ background: 'var(--color-bg-header)' }}>
                        {/*<Dropdown.ItemText style={{ color: 'var(--bs-green)' }}>{user.name}</Dropdown.ItemText>*/}
                        {
                            !!userIsVerified && menuDashboard.map(item => <Fragment key={item.path}>
                                {
                                    (!item.access || checkAccess(item.access)) &&
                                    <Dropdown.Item as={Link} to={item.path}>
                                        <BinIcon name={item.icon || 'IcNone'}/> {item.title}
                                    </Dropdown.Item>
                                }
                            </Fragment>)
                        }
                        {!!userIsVerified && <Dropdown.Divider/>}
                        <Dropdown.Item data-name={'change_password'}
                                       onClick={openProfile}>
                            <BinIcon name="IcPencil"/> Change password
                        </Dropdown.Item>
                        <Dropdown.Item data-name={'logout'}
                                       onClick={logoutHandler}>
                            <BinIcon name="IcLogOut"/> Logout
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            }
        </HeaderActionsStyled>
        <Modal show={showProfile} size={'lg'}>
            <Profile cancel={closeProfile}/>
        </Modal>

    </HeaderStyled>
}

export default Header;
